define(function riqDropdownStateModule() {
  'use strict';

  var state = function state() {
    var NAMESPACE = 'riqDropdowns';
    var ALIAS = 'riqDropdowns';

    var mutations = {
      init: function init() {
        var state = {};
        return state;
      },
      add: function add(_moduleState, _payload) {
        var nextModuleMutation = {};
        nextModuleMutation[_payload] = false;
        var nextModuleState = Object.assign(
          {},
          _moduleState,
          nextModuleMutation
        );
        return nextModuleState;
      },
      remove: function remove(_moduleState, _payload) {
        var nextModuleState = Object.assign({}, _moduleState);
        delete nextModuleState[_payload];
        return nextModuleState;
      },
      activate: function activate(_moduleState, _payload) {
        var nextModuleMutation = {};
        for (var key in _moduleState) {
          if (!_moduleState.hasOwnProperty(key)) {
            continue;
          }
          nextModuleMutation[key] = false;
        }
        nextModuleMutation[_payload] = true;
        var nextModuleState = Object.assign(
          {},
          _moduleState,
          nextModuleMutation
        );
        return nextModuleState;
      },
      deactivate: function deactivate(_moduleState, _payload) {
        var nextModuleMutation = {};
        nextModuleMutation[_payload] = false;
        var nextModuleState = Object.assign(
          {},
          _moduleState,
          nextModuleMutation
        );
        return nextModuleState;
      },
      deactivateAll: function deactivateAll(_moduleState) {
        var nextModuleMutation = {};
        for (var key in _moduleState) {
          if (!_moduleState.hasOwnProperty(key)) {
            continue;
          }
          nextModuleMutation[key] = false;
        }
        var nextModuleState = Object.assign(
          {},
          _moduleState,
          nextModuleMutation
        );
        return nextModuleState;
      }
    };

    return {
      namespace: NAMESPACE,
      alias: ALIAS,
      mutations: mutations
    };
  };

  return state;
});
